import { LANGUAGE_MAP } from 'constant/language';
import A4Render from '../components/a4-render';
import ContractHeader from '../components/contract-header';
import ContractTitle from '../components/contract-title';
import {
  ContractLang,
  ContractPrintProduct,
  ContractStyleType,
  ContractType,
} from '../utils';
import CustomerCompanyInfo from '../components/customer-company-info';
import ProductTable from '../components/product-table';
import { getShopConfig } from 'constant/shop';
import ReturnContractFooter from './return-contract-footer';

const ReturnContractTypeNameMap: Record<
  ContractType,
  Record<ContractLang, string>
> = {
  RECYCLE_CUSTOMER: {
    [LANGUAGE_MAP.JA]: '返品書（お客様控え）',
    [LANGUAGE_MAP.EN]: 'Return Receipt(Copy)',
    [LANGUAGE_MAP.ZH_CN]: '退货单据（副本）',
    [LANGUAGE_MAP.FR]: 'Reçu de retour (Copie)',
  },
  RECYCLE_STORE: {
    [LANGUAGE_MAP.JA]: '返品書',
    [LANGUAGE_MAP.EN]: 'Return Receipt',
    [LANGUAGE_MAP.ZH_CN]: '退货单据',
    [LANGUAGE_MAP.FR]: 'Reçu de retour',
  },
  SELL_CUSTOMER: {
    [LANGUAGE_MAP.JA]: '返品書（お客様控え）',
    [LANGUAGE_MAP.EN]: 'Return Receipt(Copy)',
    [LANGUAGE_MAP.ZH_CN]: '退货单据（副本）',
    [LANGUAGE_MAP.FR]: 'Reçu de retour (Copie)',
  },
  SELL_STORE: {
    [LANGUAGE_MAP.JA]: '返品書',
    [LANGUAGE_MAP.EN]: 'Return Receipt',
    [LANGUAGE_MAP.ZH_CN]: '退货单据',
    [LANGUAGE_MAP.FR]: 'Reçu de retour',
  },
};

const ReturnContract = ({
  storeId,
  contractStyleType,
  headList,
  contractLang,
  contractType,
  userInfoRenderLineList,
  memberId,
  contractPrintProductList,
}: {
  storeId: number;
  contractStyleType: ContractStyleType;
  headList: { label: string; value: string }[];
  contractLang: ContractLang;
  contractType: ContractType;
  userInfoRenderLineList: string[];
  memberId: number;
  contractPrintProductList: ContractPrintProduct[];
}) => {
  const isStoreCopy =
    contractType === 'RECYCLE_STORE' || contractType === 'SELL_STORE';
  const currencySymbol = getShopConfig(storeId).currency;
  const storeName = getShopConfig(storeId).companyName;

  return (
    <A4Render>
      <ContractTitle storeId={storeId} contractStyleType={contractStyleType} />
      <ContractHeader
        headList={headList}
        contractLang={contractLang}
        title={ReturnContractTypeNameMap[contractType][contractLang]}
        type={contractType}
        storeId={storeId}
      />
      <CustomerCompanyInfo
        contractType={contractType}
        storeId={storeId}
        userInfoRenderLineList={userInfoRenderLineList}
        contractLang={contractLang}
        memberId={memberId}
        isStoreCopy={isStoreCopy}
      />

      <ProductTable
        styleType={contractStyleType}
        showId={isStoreCopy}
        productList={contractPrintProductList}
        contractLang={contractLang}
        currencySymbol={currencySymbol}
        showPrice={false}
      />

      <ReturnContractFooter
        contractLang={contractLang}
        storeName={storeName}
        contractStyleType={contractStyleType}
        isStoreCopy={isStoreCopy}
      />
    </A4Render>
  );
};

export default ReturnContract;
